module.exports = __webpack_public_path__ + "media/images/emblems/Vouvry-2c0778197478172318c627f1cdb403d9.png";